/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminDeletePostByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminDeletePostByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetPostsByCommunityUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetPostsByCommunityUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetPostsByCommunityUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchPostByPostUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchPostByPostUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchPostByPostUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchPostByPostUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPostCommunityCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminPostCommunityInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostCommunityReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPostPostByCommunityUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostPostByCommunityUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPostPostByCommunityUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPostPostByCommunityUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminCommunitiesApi - axios parameter creator
 * @export
 */
export const AdminCommunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminDeletePostByPostUuid: async (communityPostUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('adminCommunityControllerAdminDeletePostByPostUuid', 'communityPostUuid', communityPostUuid)
            const localVarPath = `/admin/communities/posts/{communityPostUuid}`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 조회
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminGetPostsByCommunityUuid: async (communityUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityUuid' is not null or undefined
            assertParamExists('adminCommunityControllerAdminGetPostsByCommunityUuid', 'communityUuid', communityUuid)
            const localVarPath = `/admin/communities/{communityUuid}/posts`
                .replace(`{${"communityUuid"}}`, encodeURIComponent(String(communityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 수정
         * @param {string} communityPostUuid 게시글 uuid
         * @param {AdminPatchPostByPostUuidReqBodyDto} adminPatchPostByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPatchPostByPostUuid: async (communityPostUuid: string, adminPatchPostByPostUuidReqBodyDto: AdminPatchPostByPostUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityPostUuid' is not null or undefined
            assertParamExists('adminCommunityControllerAdminPatchPostByPostUuid', 'communityPostUuid', communityPostUuid)
            // verify required parameter 'adminPatchPostByPostUuidReqBodyDto' is not null or undefined
            assertParamExists('adminCommunityControllerAdminPatchPostByPostUuid', 'adminPatchPostByPostUuidReqBodyDto', adminPatchPostByPostUuidReqBodyDto)
            const localVarPath = `/admin/communities/posts/{communityPostUuid}`
                .replace(`{${"communityPostUuid"}}`, encodeURIComponent(String(communityPostUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchPostByPostUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 생성
         * @param {AdminPostCommunityReqBodyDto} adminPostCommunityReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPostCommunity: async (adminPostCommunityReqBodyDto: AdminPostCommunityReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostCommunityReqBodyDto' is not null or undefined
            assertParamExists('adminCommunityControllerAdminPostCommunity', 'adminPostCommunityReqBodyDto', adminPostCommunityReqBodyDto)
            const localVarPath = `/admin/communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostCommunityReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 생성
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {AdminPostPostByCommunityUuidReqBodyDto} adminPostPostByCommunityUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPostPostByCommunityUuid: async (communityUuid: string, adminPostPostByCommunityUuidReqBodyDto: AdminPostPostByCommunityUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityUuid' is not null or undefined
            assertParamExists('adminCommunityControllerAdminPostPostByCommunityUuid', 'communityUuid', communityUuid)
            // verify required parameter 'adminPostPostByCommunityUuidReqBodyDto' is not null or undefined
            assertParamExists('adminCommunityControllerAdminPostPostByCommunityUuid', 'adminPostPostByCommunityUuidReqBodyDto', adminPostPostByCommunityUuidReqBodyDto)
            const localVarPath = `/admin/communities/{communityUuid}/posts`
                .replace(`{${"communityUuid"}}`, encodeURIComponent(String(communityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostPostByCommunityUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCommunitiesApi - functional programming interface
 * @export
 */
export const AdminCommunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCommunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 삭제
         * @param {string} communityPostUuid 게시글 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCommunityControllerAdminDeletePostByPostUuid(communityPostUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCommunityControllerAdminDeletePostByPostUuid(communityPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCommunitiesApi.adminCommunityControllerAdminDeletePostByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 조회
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCommunityControllerAdminGetPostsByCommunityUuid(communityUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetPostsByCommunityUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCommunityControllerAdminGetPostsByCommunityUuid(communityUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCommunitiesApi.adminCommunityControllerAdminGetPostsByCommunityUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 수정
         * @param {string} communityPostUuid 게시글 uuid
         * @param {AdminPatchPostByPostUuidReqBodyDto} adminPatchPostByPostUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCommunityControllerAdminPatchPostByPostUuid(communityPostUuid: string, adminPatchPostByPostUuidReqBodyDto: AdminPatchPostByPostUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchPostByPostUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCommunityControllerAdminPatchPostByPostUuid(communityPostUuid, adminPatchPostByPostUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCommunitiesApi.adminCommunityControllerAdminPatchPostByPostUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 생성
         * @param {AdminPostCommunityReqBodyDto} adminPostCommunityReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCommunityControllerAdminPostCommunity(adminPostCommunityReqBodyDto: AdminPostCommunityReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostCommunityCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCommunityControllerAdminPostCommunity(adminPostCommunityReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCommunitiesApi.adminCommunityControllerAdminPostCommunity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 생성
         * @param {string} communityUuid 커뮤니티 uuid(카테고리)
         * @param {AdminPostPostByCommunityUuidReqBodyDto} adminPostPostByCommunityUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCommunityControllerAdminPostPostByCommunityUuid(communityUuid: string, adminPostPostByCommunityUuidReqBodyDto: AdminPostPostByCommunityUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostPostByCommunityUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCommunityControllerAdminPostPostByCommunityUuid(communityUuid, adminPostPostByCommunityUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCommunitiesApi.adminCommunityControllerAdminPostPostByCommunityUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCommunitiesApi - factory interface
 * @export
 */
export const AdminCommunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCommunitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 삭제
         * @param {AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminDeletePostByPostUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCommunityControllerAdminDeletePostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 조회
         * @param {AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminGetPostsByCommunityUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetPostsByCommunityUuidOkDto> {
            return localVarFp.adminCommunityControllerAdminGetPostsByCommunityUuid(requestParameters.communityUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 수정
         * @param {AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPatchPostByPostUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchPostByPostUuidOkDto> {
            return localVarFp.adminCommunityControllerAdminPatchPostByPostUuid(requestParameters.communityPostUuid, requestParameters.adminPatchPostByPostUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 커뮤니티 카테고리 생성
         * @param {AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPostCommunity(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostCommunityCreatedDto> {
            return localVarFp.adminCommunityControllerAdminPostCommunity(requestParameters.adminPostCommunityReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 커뮤니티 게시글 생성
         * @param {AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCommunityControllerAdminPostPostByCommunityUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostPostByCommunityUuidOkDto> {
            return localVarFp.adminCommunityControllerAdminPostPostByCommunityUuid(requestParameters.communityUuid, requestParameters.adminPostPostByCommunityUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCommunityControllerAdminDeletePostByPostUuid operation in AdminCommunitiesApi.
 * @export
 * @interface AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest
 */
export interface AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuid
     */
    readonly communityPostUuid: string
}

/**
 * Request parameters for adminCommunityControllerAdminGetPostsByCommunityUuid operation in AdminCommunitiesApi.
 * @export
 * @interface AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest
 */
export interface AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest {
    /**
     * 커뮤니티 uuid(카테고리)
     * @type {string}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuid
     */
    readonly communityUuid: string
}

/**
 * Request parameters for adminCommunityControllerAdminPatchPostByPostUuid operation in AdminCommunitiesApi.
 * @export
 * @interface AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest
 */
export interface AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest {
    /**
     * 게시글 uuid
     * @type {string}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuid
     */
    readonly communityPostUuid: string

    /**
     * 
     * @type {AdminPatchPostByPostUuidReqBodyDto}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuid
     */
    readonly adminPatchPostByPostUuidReqBodyDto: AdminPatchPostByPostUuidReqBodyDto
}

/**
 * Request parameters for adminCommunityControllerAdminPostCommunity operation in AdminCommunitiesApi.
 * @export
 * @interface AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest
 */
export interface AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest {
    /**
     * 
     * @type {AdminPostCommunityReqBodyDto}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminPostCommunity
     */
    readonly adminPostCommunityReqBodyDto: AdminPostCommunityReqBodyDto
}

/**
 * Request parameters for adminCommunityControllerAdminPostPostByCommunityUuid operation in AdminCommunitiesApi.
 * @export
 * @interface AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest
 */
export interface AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest {
    /**
     * 커뮤니티 uuid(카테고리)
     * @type {string}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuid
     */
    readonly communityUuid: string

    /**
     * 
     * @type {AdminPostPostByCommunityUuidReqBodyDto}
     * @memberof AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuid
     */
    readonly adminPostPostByCommunityUuidReqBodyDto: AdminPostPostByCommunityUuidReqBodyDto
}

/**
 * AdminCommunitiesApi - object-oriented interface
 * @export
 * @class AdminCommunitiesApi
 * @extends {BaseAPI}
 */
export class AdminCommunitiesApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 커뮤니티 게시글 삭제
     * @param {AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCommunitiesApi
     */
    public adminCommunityControllerAdminDeletePostByPostUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminDeletePostByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminCommunitiesApiFp(this.configuration).adminCommunityControllerAdminDeletePostByPostUuid(requestParameters.communityPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 커뮤니티 게시글 조회
     * @param {AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCommunitiesApi
     */
    public adminCommunityControllerAdminGetPostsByCommunityUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminGetPostsByCommunityUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminCommunitiesApiFp(this.configuration).adminCommunityControllerAdminGetPostsByCommunityUuid(requestParameters.communityUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 커뮤니티 게시글 수정
     * @param {AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCommunitiesApi
     */
    public adminCommunityControllerAdminPatchPostByPostUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPatchPostByPostUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminCommunitiesApiFp(this.configuration).adminCommunityControllerAdminPatchPostByPostUuid(requestParameters.communityPostUuid, requestParameters.adminPatchPostByPostUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 커뮤니티 카테고리 생성
     * @param {AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCommunitiesApi
     */
    public adminCommunityControllerAdminPostCommunity(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPostCommunityRequest, options?: RawAxiosRequestConfig) {
        return AdminCommunitiesApiFp(this.configuration).adminCommunityControllerAdminPostCommunity(requestParameters.adminPostCommunityReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 커뮤니티 게시글 생성
     * @param {AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCommunitiesApi
     */
    public adminCommunityControllerAdminPostPostByCommunityUuid(requestParameters: AdminCommunitiesApiAdminCommunityControllerAdminPostPostByCommunityUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminCommunitiesApiFp(this.configuration).adminCommunityControllerAdminPostPostByCommunityUuid(requestParameters.communityUuid, requestParameters.adminPostPostByCommunityUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

